module.exports = __webpack_public_path__ + "img/target.bc26ae7b.png";